import { api } from '@/shared/api';

export const getNearestSearches = (query: string, dateRange: number) => {
  return api.lowPrices
    .getCalendar(query, { date_range: dateRange })
    .then(res => res.data);
};
